import React from "react";
import {PageRouteProvider} from "@reapptor-apps/reapptor-react-common";
import AnonymousPage from "../../models/base/AnonymousPage";
import {
  Icon,
  IconStyle,
  PageContainer,
  PageHeader,
} from "@reapptor-apps/reapptor-react-components";
import Localizer from "../../localization/Localizer";
import styles from "./OpeningHours.module.scss";
import PageDefinitions from "@/providers/PageDefinitions";
import {DynamicPageData, DynamicPageResponse, DynamicPageResponseSingleType} from "@/models/cms/DynamicPageResponse";
import ReactMarkdown from "react-markdown";
import MetaTags from "@/components/MetaTags/MetaTags";
import _ from "lodash";

export interface IOpeningHoursParams {}

interface IOpeningHoursState {
  locations: DynamicPageData[];
  openingHoursPageData: DynamicPageData | null;
}

export default class OpeningHours extends AnonymousPage<IOpeningHoursParams, IOpeningHoursState> {
  state: IOpeningHoursState = {
    locations: [],
    openingHoursPageData: null
  };

  public async initializeAsync(): Promise<void> {
    const response: DynamicPageResponse = await this.getAsync(
        "/api/Application/GetDynamicPageContent?contentType=locations&deepPopulate=openingHours&sort=externalId"
    );
    if (response.data) {
      const order = ['1', '3', '4', '5', '2'];
      const sortedLocations = _.sortBy(response.data, function(obj){
        return _.indexOf(order, obj.attributes.externalId);
      });
      this.setState({locations: sortedLocations});
    }

    const openingHoursPageResponse: DynamicPageResponseSingleType = await this.getAsync(
        "/api/Application/GetDynamicPageContent?contentType=opening-hours-info&populate=*"
    );
    if(openingHoursPageResponse?.data?.attributes){
      this.setState({...this.state, openingHoursPageData: openingHoursPageResponse.data})
    }
    
    window.scrollTo(0,0);
  }

  public getTitle(): string {
    return Localizer.openingHoursPageTitle;
  }

  public render(): React.ReactNode {
    return (
        <PageContainer fullWidth className={styles.pageContainer}>
          <MetaTags pageName="OpeningHours" />
          <PageHeader className={styles.pageHeader} title={Localizer.openingHoursPageTitle}/>

          <div className={styles.pageContent}>
            <div className={this.css(styles.fluidContent, styles.container)}>
              {this.state.openingHoursPageData ? (
                  <div className={styles.specialOpeningHoursContainer}>
                    {this.state.openingHoursPageData?.attributes?.content ? (
                        <div className={styles.specialOpeningHoursTextWrapper}>
                          <ReactMarkdown>{this.state.openingHoursPageData.attributes?.content ?? ''}</ReactMarkdown>
                        </div>
                    ) : null}
                    {(this.state.openingHoursPageData?.attributes?.additionalContent) ? (
                        <div className={styles.specialOpeningHoursTextWrapper}>
                          <ReactMarkdown>{this.state.openingHoursPageData.attributes?.additionalContent ?? ''}</ReactMarkdown>
                        </div>
                    ): null}
                  </div>
              ) : null}
              <div className={styles.box}>
                  <h2>{Localizer.openingHoursPageTitle}</h2>
                  <div className={styles.locationsContainer}>
                    {this.state.locations &&
                        this.state.locations.map((location) => {
                          return (
                              <div
                                  className={styles.location}
                              >
                                <h6 onClick={async () =>
                                    await PageRouteProvider.redirectAsync(
                                        PageDefinitions.location.route({
                                          params: {selectedLocation: location.attributes.externalId}
                                        })
                                    )
                                }>{location.attributes.name}</h6>
                                <div>{location.attributes.address}</div>
                                <div>
                                  {location.attributes.postalCode} {location.attributes.town}
                                </div>
                                <div className={styles.openingHoursContainer}>
                                  <div className={styles.openingHoursTextDiv}>
                                    {Localizer.locationPageOpeningHours}:
                                  </div>
                                  {location.attributes.openingHours && location.attributes.openingHours.TitleHoursPair.length > 0 &&
                                      <div className={styles.openingHoursTable}>
                                        {location.attributes.openingHours?.TitleHoursPair.map((hoursPair, index) => {
                                          return(
                                              <div key={index} className={styles.openingHoursRow}>
                                                <span>{hoursPair.Title}</span>
                                                <span>{hoursPair.Hours}</span>
                                              </div>
                                          )
                                        })}
                                      </div>
                                  }
                                  {(location.attributes.externalId === "2" && (!location.attributes.openingHours)) &&
                                      <div>
                                          <span>{Localizer.locationPageAccordingToAgreement}</span>
                                      </div>
                                  }
                                  {(location.attributes.phoneNumber && location.attributes.phoneNumber.length > 0) &&
                                      <div className={styles.phoneNumber}>
                                          <span><Icon name='phone' style={IconStyle.Light}/></span>
                                          <span>
                                              <a href={`tel:${location.attributes.phoneNumber?.replace(/\s+/g, '')}`}>
                                                  {location.attributes.phoneNumber}
                                              </a>
                                          </span>
                                      </div>
                                  }
                                </div>
                              </div>
                          );
                        })}
                  </div>
              </div>
            </div>
          </div>
        </PageContainer>
    );
  }
}
